export default [
  {
    path: 'applydocorg',
    name: 'applydocorg',
    component: () => import('@/views/pages/dashboard/chart/CountByApplyDocResearcherRegionOrgComponent.vue'),
    meta: {
      pageTitle: 'Applicants by dc type',
      breadcrumb: [
        {
          text: 'Applicants by dc type',
          active: true,
        },
      ],
      resource: 'Home',
    },
  },
]
